<div *ngIf="PartialViewReady">
    <h2 class="mat-title">Available Reports</h2>
    <div>You may choose from among the following available reports:</div>
    <div *ngIf="!SmallDisplay">
        <div class="topmargin bottommargin" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px" *ngFor="let item of AvailableReports; let $last = last" [class.bottomborder]="!$last">
            <div fxLayout="column" fxLayoutAlign="start stretch">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <mat-icon>{{item.IconName || 'description'}}</mat-icon>
                    <h3 class="nomargin">{{item.Title}}</h3>
                </div>
                <div class="toppadding bottompadding">
                    <em><span [innerHTML]="item.Description | safeHTML" fxFlex></span></em>                    
                </div>
            </div>
            <div>
                <button mat-raised-button color="primary" (click)="RunReport(item)">Run Report</button>
            </div>
        </div>
    </div>
    <div *ngIf="SmallDisplay" fxLayout="column" fxLayoutAlign="start stretch">
        <div *ngFor="let item of AvailableReports;let $even = even" [class.primarybackground50]="$even" fxLayout="column" fxLayoutAlign="start stretch">
            <h3>{{item.Title}}</h3>
            <div [innerHTML]="item.Description | safeHTML"></div>
            <div class="smalldisplaybuttongroup" fxLayout="row" fxLayoutAlign="center center">
                <button mat-raised-button color="primary" (click)="RunReport(item)">Run Report</button>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/reports/reports.component.html